/* Product Template Scripts */

// Smooth scroll to reviews function
function goToLargeReview() {
  if (document.querySelector(".custom-heading-h2")) {
    document.querySelector(".custom-heading-h2").scrollIntoView({ behavior: 'smooth'});
  }
}

// Initialize product template functionality
document.addEventListener('DOMContentLoaded', function () {
  
  // Review scroll functionality
  setTimeout(() => {
    // Select the target node.
    var target = document.querySelector('.yotpo-reviews.yotpo-active');
    
    if (target) {
      // Create an observer instance.
      var observer = new MutationObserver(function(mutations) {
        setTimeout(() => {
          if (typeof $ !== 'undefined') {
            $('html, body').animate({
              scrollTop: $(".section-yotpo-main.product__wrapper").offset().top - 200
            }, 1000);
          } else {
            // Fallback for vanilla JS
            const targetElement = document.querySelector(".section-yotpo-main.product__wrapper");
            if (targetElement) {
              const offsetTop = targetElement.offsetTop - 200;
              window.scrollTo({ top: offsetTop, behavior: 'smooth' });
            }
          }
        }, 500);
      });

      // Pass in the target node, as well as the observer options.
      observer.observe(target, {
        attributes: true,
        childList: true,
        characterData: true
      });
    }
  }, 2000);
});

// Swiper initialization
document.addEventListener('DOMContentLoaded', function () {
  // Wait for Swiper to be loaded
  const initSwiper = () => {
    if (typeof Swiper === 'undefined') {
      setTimeout(initSwiper, 100);
      return;
    }

    var sliderThumbnail = new Swiper('.slider-thumbnail', {
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      direction: 'horizontal',
      breakpoints: {
        320: { direction: 'horizontal' },
        1023: {
          direction: 'vertical',
        },
      },
      mousewheel: { sensitivity: 0.5, thresholdDelta: 10 },
    });

    var slider = new Swiper('.slider', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next-slider',
        prevEl: '.swiper-button-prev-slider',
      },
      thumbs: { swiper: sliderThumbnail },
      mousewheel: { sensitivity: 0.5, thresholdDelta: 10 },
      on: {
        init: function() {
          // Show badges on initial load (first slide)
          const badges = document.querySelector('.product-new-badges');
          if (badges) badges.style.display = 'flex';
        },
        slideChange: function () {
          // Handle video pause/play
          document.querySelectorAll('.swiper-container.slider video').forEach(function (video) {
            video.pause();
            video.currentTime = 0;
          });

          var activeVideo = this.slides[this.activeIndex].querySelector('video');
          if (activeVideo) activeVideo.play();

          // Handle badges visibility
          const badges = document.querySelector('.product-new-badges');
          if (badges) {
            if (this.realIndex === 0) {
              badges.style.display = 'flex';
            } else {
              badges.style.display = 'none';
            }
          }
        },
      },
    });

    // Thumbnail navigation buttons
    const prevThumbnailButton = document.querySelector('.swiper-button-prev.slider-thumbnail-button-prev');
    const nextThumbnailButton = document.querySelector('.swiper-button-next.slider-thumbnail-button-next');
    
    if (prevThumbnailButton) {
      prevThumbnailButton.addEventListener('click', function () {
        const prevButton = document.querySelector('.swiper-button-prev.swiper-button-prev-slider');
        if (prevButton) prevButton.click();
      });
    }
    
    if (nextThumbnailButton) {
      nextThumbnailButton.addEventListener('click', function () {
        const nextButton = document.querySelector('.swiper-button-next.swiper-button-next-slider');
        if (nextButton) nextButton.click();
      });
    }

    // Video controls
    document.querySelectorAll('.swiper-container.slider video').forEach(function (video) {
      video.setAttribute('playsinline', '');
      video.addEventListener('click', function () {
        if (this.paused) {
          this.play();
        } else {
          this.pause();
        }
      });
    });

    // Play initial video if exists
    var activeVideo = slider.slides[slider.activeIndex].querySelector('video');
    if (activeVideo) activeVideo.play();
  };

  initSwiper();
});